<div class="container" (mouseover)="onMouseMove($event)" (mouseleave)="onMouseLeave()">
  <google-chart [data]="chartData" (chartReadyOneTime)="onReady()"></google-chart>
  <div [ngClass]="{'show-tooltip': showTooltip}" class="values">
    <div class="gebruik">{{gemiddeldGebruik | number:'1.1-1'}} keer p/w</div>
    <div class="tooltip">{{actualTooltip}}</div>
  </div>
</div>
